import { createSlice } from "@reduxjs/toolkit";

export const supplierSlice = createSlice({
  name: "supplier",
  initialState: {
    all: [],
    byId: [],
    isLoading: true,
  },
  reducers: {
    load: (state, action) => {
      state.all = action.payload.data;
      state.byId = action.payload.data.map((data) => data.id);
      state.isLoading = false;
    },
    update: (state, action) => {
      state.all = state.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },
    create: (state, action) => {
      state.all.push({ ...action.payload });
      state.byId.push(action.payload.id);
    },
    remove: (state, action) => {
      state.all = state.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.byId = [...state.byId].reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },
  },
});

export const { load, create, update, remove } = supplierSlice.actions;

export default supplierSlice.reducer;
